
import { Loader } from "@googlemaps/js-api-loader"
const DEFAULT_POSITION = {
  LAT: 22.282998,
  LNG: 114.133834
}
const ZOOM_LEVEL = 15
export default {
  props: {
    storeList: {
      type: Array,
      default: () => []
    },
    currentStoreId: {
      type: Number,
      default: null
    },
    services: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      map: null,
      googlemaps: null,
      infoWindows: [],
      loader: new Loader({
        apiKey: "AIzaSyCJ5s8_GqN4meRRYs37RKK3ixzUApDblYk",
        version: "weekly",
        libraries: ["places"]
      })
    }
  },
  computed: {
    currentStore() {
      return (
        this.storeList.find(item => item.storeId == this.currentStoreId) ||
        this.storeList?.[0] || {
          latitude: DEFAULT_POSITION.LAT,
          longitude: DEFAULT_POSITION.LNG
        }
      )
    }
  },
  watch: {
    currentStoreId() {
      this.infoWindows.forEach(infoWindow => {
        if (infoWindow.id != this.currentStoreId) {
          infoWindow.close()
        } else {
          infoWindow.open({
            anchor: infoWindow.marker,
            map: this.map
          })
          console.log(infoWindow)
        }
      })
      if (this.map) {
        this.map.setCenter({
          lat: this.currentStore.latitude,
          lng: this.currentStore.longitude
        })
      }
    }
  },
  mounted() {
    this.initMap()
  },
  methods: {
    async initMap() {
      const googlemaps = await this.loader.importLibrary("maps")
      const { Marker } = await this.loader.importLibrary("marker")
      this.googlemaps = googlemaps
      this.Marker = Marker
      const mapOptions = {
        zoom: ZOOM_LEVEL,
        fullscreenControl: false,
        mapTypeControl: false,
        mapId: "4504f8b37365c3d0",
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP
        }
      }
      this.map = new this.googlemaps.Map(this.$refs.map, {
        center: { lat: this.currentStore.latitude, lng: this.currentStore.longitude },
        ...mapOptions
      })
      this.addWellcomeMarker()
    },

    addWellcomeMarker() {
      const locations = this.storeList.map(item => {
        return {
          lat: item.latitude,
          lng: item.longitude,
          id: item.storeId
        }
      })
      locations.forEach(location => {
        this.addMarker(location)
      })
      if (this.infoWindows.length > 0) {
        this.infoWindows[0].open({
          anchor: this.infoWindows[0].marker,
          map: this.map
        })
      }
    },
    getServiceImgUrl(id) {
      return this.services.find(item => item.id == id)?.imgUrl
    },
    addMarker(location) {
      const marker = new this.Marker({
        position: location,
        map: this.map,
        icon: this.$webHelper.getImgUrl("store_marker.png")
      })
      const storeInfo = this.storeList.find(item => item.storeId == location.id)

      const contentString = `
  <div class="store-locator-store-info" style="width: 3rem;">
    <div>
      <div class="name">${storeInfo.storeName}</div>
      <div class="address">${storeInfo.storeAddress}</div>
    </div>
    <div>
      <div class="title">Opening hours</div>
      <div class="info">${storeInfo.openingHours}</div>
    </div>
    <div>
      <a class="direction" target="_blank" href="https://www.google.com/maps/dir/Current+Location/${storeInfo.storeAddress}">
      Get directions
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.3333 7.99622C11.3333 8.10884 11.3083 8.22147 11.2666 8.32543C11.2165 8.43805 11.1498 8.53335 11.0663 8.61999L5.99333 13.7661C5.85149 13.922 5.65958 14 5.45099 14C5.30914 14 5.17564 13.9653 5.05883 13.896C4.94202 13.8267 4.85024 13.7228 4.77514 13.6101C4.70005 13.4889 4.66668 13.3502 4.66668 13.203C4.66668 12.9777 4.75011 12.7698 4.90864 12.6138L9.47268 7.99622L4.90865 3.37859C4.75846 3.23131 4.66668 3.01472 4.66668 2.79814C4.66668 2.65086 4.70005 2.51224 4.77515 2.39095C4.8419 2.26967 4.94202 2.17437 5.05883 2.10506C5.17565 2.03575 5.31749 1.99243 5.45099 2.0011C5.65124 2.0011 5.85149 2.07907 5.99333 2.23501L11.0663 7.37245C11.1498 7.45042 11.2165 7.55438 11.2666 7.65834C11.3083 7.7623 11.3333 7.88359 11.3333 7.99622Z" fill="#869603"/>
      </svg>

      </a>
    </div>
  </div>
     `

      const infowindow = new this.googlemaps.InfoWindow({
        content: contentString,
        shouldFocus: true,
        id: location.id
      })
      infowindow.marker = marker

      marker.addListener("click", event => {
        this.closeInfoWindows()
        this.$emit("change", infowindow.id)
        infowindow.open({
          anchor: marker,
          map: this.map,
          shouldFocus: true
        })
      })
      this.infoWindows.push(infowindow)
    },
    closeInfoWindows() {
      this.infoWindows.forEach(infoWindow => {
        infoWindow.close()
      })
    }
  }
}
